import React from 'react';

import { IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { AlineTooltip } from 'src/components';
import { VersionHistoryIcon } from 'src/components/icons/VersionHistoryIcon';
import { getDocumentLatestVersionHref, useGetCurrentDoc } from 'src/hooks';

interface VersionHistoryButtonProps {
  documentId: UUID;
  disabled?: boolean;
}

export function VersionHistoryButton({ disabled }: VersionHistoryButtonProps): JSX.Element {
  const { document } = useGetCurrentDoc();
  const href = getDocumentLatestVersionHref(document);
  const canNavigate = href !== undefined && !disabled;

  return (
    <AlineTooltip arrow placement="bottom" title="Version history">
      <div>
        <IconButton
          disabled={!canNavigate}
          size="small"
          {...(canNavigate ? { component: Link, to: href } : {})}
        >
          <VersionHistoryIcon />
        </IconButton>
      </div>
    </AlineTooltip>
  );
}
